const publicVariable = {
  
// 故障系统
  abortSituationOptions: [
    { label: '动力电池系统', value: 0 },
    { label: '电机电控系统', value: 1 },
    { label: '底盘系统', value: 2 },
    { label: '内外饰系统', value: 3 },
    { label: '车身系统', value: 4 },
    { label: '增程系统', value: 7 },
    { label: '汽车电子系统', value: 5 },
    { label: '附件系统', value: 6 }
  ],
  abortSituationOptions2: [
    { label: '动力电池系统', value: '动力电池系统' },
    { label: '电机电控系统', value: '电机电控系统' },
    { label: '底盘系统', value: '底盘系统' },
    { label: '内外饰系统', value: '内外饰系统' },
    { label: '车身系统', value: '车身系统' },
    { label: '增程系统', value: '增程系统' },
    { label: '汽车电子系统', value: '汽车电子系统' },
    { label: '附件系统', value: '附件系统' }
  ]
}

export default
{
  publicVariable
}

